import { PAUSED_EMAIL_CONVERSATIONS, getRoute } from '../util/Routes';
import { get } from '../util/Request';
import { PausedEmailConversationsResponse } from './types/PauseEmailConversation';







export default async function getPausedEmailConversations(
    taskStatus: string,
    pageSize: number
): Promise<PausedEmailConversationsResponse> {
    if (!taskStatus) {
        throw new TypeError(
            'Error calling method getPausedEmailConversations(). <string>status is a required parameter.'
        );
    }

    const requestURL = getRoute(PAUSED_EMAIL_CONVERSATIONS).path;
    const param = {
        status: 'pause',
        pageSize: pageSize || 50
    };
    return get<PausedEmailConversationsResponse>(requestURL, param);
}
